// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`. 'https://devfcolapi.appfcol.com' ' http://localhost:8080/machinax/apiN' ' http://localhost:8080/fertilidade/api' 'https://api.appfcol.com'
const production: boolean = false;


// variaveis do onesignal
const onesignalAppId   = '80ed673f-5ec4-430c-ab66-f0adaf2addb5',
      onesinalAndroidId = '23276053359';

// Variaveis da API
const apiBaseUrl:    string = 'https://api.appfcol.com';     

const apiAuthMethod: string = 'basic',
      apiVersion:    string = 'v1',
      apiBasicAuth:  string = 'Basic ' + window.btoa('dmc'+":"+'999159389'), 
      apiRoutes:     any    = {
        'login'       : 'fcol/Account/login', // Post para logar (username e password),
        'user_create' : 'fcol/Account/create', // Post para criar usuário
        'user_update' : 'fcol/Account/update', // Post para criar usuário
        'user_remove' : 'fcol/Account/remove', // Post para remover usuário
        

        'signature_item': 'fcol/Signature/item', // Post para recuperar dados da assinatura do usuário
        'signature_create': 'fcol/Signature/create', // Post para criar dados da assinatura do usuário
        'signature_update': 'fcol/Signature/update', // Post para atualizar dados da assinatura do usuário
        'signature_check':  'fcol/Signature/check', // Post para atualizar dados da assinatura do usuário

        'password_recover' :  'fcol/Account/passwordRecover', // Solicitar e-mail com codigo para troca de senha
        'password_codeCheck': 'fcol/Account/passwordRandomCheck', // Checar se o códgo é válido
        'password_update' :   'fcol/Account/passwordUpdate', // Atualizar a senha
        
        'record_create' : 'fcol/Record/create', // Post para criar prontuario do usuario (userHash)
        'record_update' : 'fcol/Record/update', // Post para atualizar o prontuario da usuaria
        'control_update': 'fcol/Record/controlUpdate', // Post para criar usuário


        'menstruations_create' : 'fcol/Menstruations/create', // Post para criar Menstruações (as 4 primeiras)
        'menstruations_update' : 'fcol/Menstruations/update', // Post para criar Menstruações (as 4 ultimas),
        'menstruations_set'    : 'fcol/Menstruations/set',    // Post para criar a menstruação mais recente,
        'menstruations_items'  :  'fcol/Menstruations/items', // Post retornar as menstruações,
        
        'fertilityTest_items' : 'fcol/FertilityTest/items',
        'fertilityTest_create': 'fcol/FertilityTest/create', // Post para criar o teste de fertilidade do usuário

        'notes_items' : 'fcol/Notes/items',
        'notes_create': 'fcol/Notes/create',
        'notes_update': 'fcol/Notes/update', 
        'notes_delete': 'fcol/Notes/delete',

        'notifications_set': 'fcol/Notifications/set?type=calendar' // Post para notificacoes do calendario do teste de fertilidade


       
      },    
      apiRequestOptions: any = {
        headers: {
          'Content-Type':  'application/x-www-form-urlencoded'
        }
      };

// Setar o tipo de autorização com base no authMethod da API
apiRequestOptions.headers['Authorization'] = (apiAuthMethod == 'basic') ? apiBasicAuth : '';


// Variaveis do aplicativo
const appLogo = 'assets/images/fcol/logo_contrast.png',
      appLogoSmall = 'assets/images/fcol/logo_menu.png',
      appLoggedRoute = 'dashboard',
      appMenuButtonLogout = true, // Adiciona o item logou ao menu do split panel
      appMultilanguage = true;
  

// Exportar JSON com as variáveis
export const environment: any = {
        production: production,
        apiBaseUrl: `${apiBaseUrl}/${apiVersion}/`, 
        apiRoutes: apiRoutes,
        requestOptions: apiRequestOptions,
        appLogo: appLogo,
        appLogoSmall: appLogoSmall,
        appLoggedRoute: appLoggedRoute,
        appMultilanguage: appMultilanguage, 
        appMenuButtonLogout: appMenuButtonLogout, 
        onesignalAppId: onesignalAppId,
        onesinalAndroidId: onesinalAndroidId
};




/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
